module.exports = __webpack_public_path__ + "static/preview-8ce8f057ef171d70834166187cb6bbbc.jpg";